module.exports = __webpack_public_path__ + "static/img/14000698.c3493513.png";